import React from 'react';
import { cn } from '../../lib/utils';

/**
 * NEXORA Ocean Design System (NODS)
 * Input Component
 * 
 * Based on design_guidelines.json:
 * - Soft 1px border
 * - Distinct focus rings (ring-2 ring-primary/20)
 * - Shadcn heavily customized
 */

export const Input = React.forwardRef((
  { className, type = 'text', error, ...props },
  ref
) => {
  return (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-10 w-full rounded-lg border bg-surface px-3 py-2 text-sm text-text-primary placeholder:text-text-secondary',
        'focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'transition-colors duration-200',
        error ? 'border-error focus:ring-error/20 focus:border-error' : 'border-border',
        className
      )}
      {...props}
    />
  );
});

Input.displayName = 'Input';

export default Input;
